import React from "react";
import classes from "./AlsoLike.module.scss";
import { Link } from "react-router-dom";

const AlsoLike = ({ image, title, nav1, nav2, nav3 }) => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <section className={`${classes.also_like} ${classes.container}`}>
      <p className={classes.alsoLike_heading}>You may also like</p>
      <section className={classes.product_units}>
        <div className={classes.product_unit}>
          <img src={image[0]} />
          <div className={classes.item_info}>
            <p className={classes.product_title}>{title[0]}</p>
            <Link
              to={nav1}
              className={classes.see_product}
              onClick={scrollToTop}
            >
              See product
            </Link>
          </div>
        </div>
        <div className={classes.product_unit}>
          <img src={image[1]} />
          <div className={classes.item_info}>
            <p className={classes.product_title}>{title[1]}</p>
            <Link
              to={nav2}
              className={classes.see_product}
              onClick={scrollToTop}
            >
              See product
            </Link>
          </div>
        </div>
        <div className={classes.product_unit}>
          <img src={image[2]} />
          <div className={classes.item_info}>
            <p className={classes.product_title}>{title[2]}</p>
            <Link
              to={nav3}
              className={classes.see_product}
              onClick={scrollToTop}
            >
              See product
            </Link>
          </div>
        </div>
      </section>
    </section>
  );
};

export default AlsoLike;
